import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Container, Box, BoxContainer } from './styles';
import { Link } from '@mui/material';
import { getEnv } from 'utils';

const Props = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
};

export default function Tooltip({ title, children, href }) {
  const containerRef = useRef(null);
  const boxRef = useRef(null);

  return (
    <>
      <Container ref={containerRef}>
        {href && (
          <BoxContainer ref={boxRef} height={60}>
            <Link href={`${getEnv('MTG_URL_APP')}${href}`} underline="hover">
              <Box aria-label={title}>{title}</Box>
            </Link>
          </BoxContainer>
        )}
        {children}
      </Container>
    </>
  );
}
Tooltip.propTypes = Props;
